<template>
  <div>
    <transition
      enter-active-class="animated anifull"
      @enter="tEnter"
      @after-enter="afterLeave"
      v-if="isandroid && !IsTV"
    >
      <div class="full-screen" :class="[beginClass]" v-if="showFull">
        <div class="itemimg" v-if="!isfull" @click="setFull">
          <img :src="fullImg" alt="" />
        </div>
        <div class="itemimg" v-else @click="cancelFull">
          <img :src="cancel" alt="" />
        </div>
        <p class="full-info" @click="setFull" v-if="hiddeText">
          点击此按钮可切换横竖屏
        </p>
      </div>
    </transition>
    <el-slider
      class="slider-block"
      :show-tooltip="false"
      v-model="value1"
      vertical
      :max="6"
      :min="1"
      :step="0.1"
      height="10rem"
      v-if="ismobile"
    ></el-slider>
  </div>
</template>

<script>
import { debounce } from '@/utils'
export default {
  name: '',
  props: ['isfull', 'ismobile', 'isandroid'],
  data () {
    return {
      fullImg: require('@/assets/images/mobile/fullscreen.png'),
      cancel: require('@/assets/images/mobile/cancelfullscreen.png'),
      showFull: false,
      beginClass: '',
      value1: 1,
      s: null,
      hiddeText: true
    }
  },
  computed: {},
  created () {
    this.$bus.$on('fullScreenUpdate', this.setScaleNum)
    this.$once('hook:beforeDestory', () => {
      this.$bus.$off('fullScreenUpdate')
    })
  },
  mounted () {
    setTimeout(() => {
      this.showFull = true
    }, 2000)
    this.s = debounce(() => {
      document.getElementById('main-wrap').style.overflow = 'auto'
      window.sessionStorage.setItem('mainWrapper', this.value1)
    }, 100)
  },
  watch: {
    value1: {
      handler: function (newValue, oldValue) {
        let mainwrap = document.getElementById('main-wrap')
        let main = document.getElementById('main')
        // console.log(main)
        if (main) {
          main.style.transform = `scale(${newValue})`
        }
        mainwrap.style.overflow = 'hidden'
        this.s()
      }
    }
  },
  methods: {
    setScaleNum () {
      let sessionScaleNum = window.sessionStorage.getItem('mainWrapper')
      if (sessionScaleNum) {
        this.value1 = +sessionScaleNum
      }
    },
    setFull () {
      this.$emit('setFull')
    },
    cancelFull () {
      this.$emit('cancelFull')
    },
    afterLeave () {
      console.log('end')
      this.beginClass = 'full-screen-after'
    },
    tEnter (el, done) {
      let e = el
      setTimeout(() => {
        done()
        this.hiddeText = false
      }, 3000)
    }
  },
  components: {}
}
</script>

<style scoped lang="stylus">
.full-screen
  position: fixed
  //width 1.5rem
  //height 1.5rem
  width 8rem
  height 8rem
  //left: 3%;
  //bottom: 5%;
  // border-radius: 50%;
  //overflow: hidden;
  background-color: rgba(28,24,57,0.561);
  left 50%
  top 50%
  transform translate(-50%,-50%)
  opacity 1
.full-screen-after
  transform translate(0%,0%)
  left: 6%;
  top: 87%;
  width 1.5rem
  height 1.5rem
.itemimg,img
  width 100%
  height 100%
.itemimg
  position: absolute

.animated
   animation fullbegin 3s forwards

@keyframes fullbegin
  0%
    opacity .2
  10%
    opacity 1
  20%
    opacity .2
  30%
    opacity 1
  40%
    opacity .2
  50%
    opacity 1
    width 8rem
    height 8rem
    left 50%
    top 50%
    transform translate(-50%,-50%)
  90%
    opacity 1
    width 1.5rem
    height: 1.5rem
    left: 6%
    top: 87%
    transform translate(0%,0%)
  100%
    opacity 1
    width 1.5rem
    height: 1.5rem
    left: 6%
    top: 87%
    transform translate(0%,0%)

.full-info
  position: absolute
  left: 50%
  top: 50%
  fontSize .5rem
  color: #939393
  transform translate(-50%,-50%)
  white-space nowrap
  animation full-info 3s forwards

@keyframes full-info
  0%
    opacity 1
  90%
    opacity 0
    display none
  100%
    opacity 0
    display none
.slider-block
  position: fixed;
  right: 2%;
  bottom: 15%;
</style>
